import API from "@/interceptors/Api";
import type { CashPoolingUserRole } from "../types/role.types";

export const getAllRoles = async (): Promise<CashPoolingUserRole[]> => {
  const response = await API.get("/cash-pooling/roles");
  return response as unknown as CashPoolingUserRole[];
};
